import { CheckboxControl } from './CheckboxControl';

export default CheckboxControl;
